import { userReducer } from '../../../redux/resources/user';
import { payersReducer } from '../../../redux/resources/payers';

export const reducers = {
  payers: payersReducer,
  user: userReducer,
};
